<template>
    <div>
        <label class="label" :class="{ 'required': required }">
            {{ label }}
        </label>

        <v-textarea outlined dense counter :rules="rules" :hint="max_length_warning" rows="2" :value="value"
            @input="valueChanged" :disabled="disabled" :readonly="readonly" :maxlength="maxLength">
            <template v-slot:counter="slotProps">
                {{ slotProps.props.value || 0 }} / {{ maxLength }}
            </template>
        </v-textarea>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            default: "",
        },
        label: {
            required: true
        },
        required: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },

        // NEW PROP
        maxLength: {
            type: Number,
            default: 255
        }
    },

    computed: {
        max_length_warning() {
            return `Max ${this.maxLength} characters`;
        },

        rules() {
            return [
                v =>
                    (v?.length || 0) <= this.maxLength ||
                    `Max ${this.maxLength} characters`
            ];
        }
    },

    methods: {
        valueChanged(val) {
            //to prevent error in null value
            this.$emit("input", val);
        }
    }
}
</script>